import {makeObservable, observable, runInAction} from 'mobx';

import type {TelephoneOptions} from '@/components/base/PhoneNumber';
import type ICountry from '@/models/Countries';
import type ILanguage from '@/models/Languages';
import {IP_CAPTCHA} from '@/utils/constants/api-urls';
import axios from '@/utils/helpers/axios';

export default class PlatformDataStore {
  public countries: ICountry[] = [];
  public languages: ILanguage[] = [];

  public isIPAllowed = false;
  constructor(countries: ICountry[], languages: ILanguage[]) {
    this.countries = countries || [];
    this.languages = languages || [];
    this.checkIsIPAllowed();
    makeObservable(this, {
      isIPAllowed: observable,
      countries: observable,
      languages: observable,
    });
  }

  public getTelephones = () => {
    const res = this.countries?.reduce((acc: TelephoneOptions[], v) => {
      if (v.telephone.dialCode)
        acc.push({
          countryCode: v.iso3166_1.alpha_2,
          countryName: v.countryPreferredName,
          dialCode: v.telephone.dialCode,
          patterns: v.telephone.stringFormats,
          maxPhoneLength: v.telephone.stringFormats.length > 0 ? v.telephone.stringFormats[0].split('#').length - 1 : 10,
        });
      return acc;
    }, []);
    return res;
  };
  public getCountryPreferredName = (countryCode: string) => {
    return this.countries?.find((v: ICountry) => v.iso3166_1.alpha_2 === countryCode)?.countryPreferredName || '';
  };
  public checkIsIPAllowed = async () => {
    try {
      const {data: ipStatus} = await axios.get(IP_CAPTCHA.CHECK_IS_IP_ALLOWED);
      runInAction(() => {
        if (ipStatus.succeeded) {
          this.isIPAllowed = ipStatus.data;
        }
      });
    } catch (err) {
      console.log('error', err);
    }
  };
}
